// User profile types for Firestore

export type UserRole = "guest" | "free" | "premium" | "platinum" | "admin";
export type EmailFrequency = "daily" | "weekly" | null;
export type SubscriptionStatus = "active" | "canceled" | "past_due" | null;

// Subscription plans
export interface SubscriptionPlan {
  id: "free" | "premium" | "platinum";
  name: string;
  nameKo: string;
  price: number;
  priceYearly: number;
  features: string[];
  hasAds: boolean;
  popular?: boolean;
}

export interface UsageTracking {
  wordLookups: number;
  quizzesTaken: number;
  lastReset: string; // ISO timestamp
}

export interface UserLocation {
  state: string; // NSW, VIC, QLD, etc.
  suburb?: string; // suburb ID (eastwood, strathfield, etc.)
  lat?: number;
  lng?: number;
}

export interface UserProfile {
  uid: string;
  email: string;
  displayName: string | null;
  nickname?: string | null;
  nicknameDisplay?: string | null;
  nicknameFixed?: number;
  nicknameRequired?: boolean;
  suburb?: string | null;
  regionCode?: string | null;
  photoURL: string | null;
  role: UserRole;
  selectedRegion?: string; // Australian state code (NSW, VIC, QLD, etc.) - DEPRECATED, use location
  location?: UserLocation; // User's location (state, suburb, coordinates)
  emailFrequency: EmailFrequency;
  preferredCategories: string[];
  usageTracking: UsageTracking;
  stripeCustomerId: string | null;
  stripeSubscriptionId: string | null;
  subscriptionStatus: SubscriptionStatus;
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
}

export interface FreeTierLimits {
  wordLookupsPerDay: 5;
  maxSavedWords: 20;
  quizzesPerWeek: 2;
  flashcardsPerDay: 20;
}

export const FREE_TIER_LIMITS: FreeTierLimits = {
  wordLookupsPerDay: 5,
  maxSavedWords: 20,
  quizzesPerWeek: 2,
  flashcardsPerDay: 20,
};

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: "free",
    name: "Free",
    nameKo: "무료 회원",
    price: 0,
    priceYearly: 0,
    hasAds: true,
    features: [
      "모든 기사 읽기",
      "3가지 언어 모드",
      "TTS 음성 듣기",
      "단어 저장 (20개 제한)",
      "리딩 퀴즈 (주 2회)",
      "플래시카드 (하루 20장)",
    ],
  },
  {
    id: "premium",
    name: "Premium",
    nameKo: "프리미엄",
    price: 3.99,
    priceYearly: 39.99,
    hasAds: true,
    popular: true,
    features: [
      "무료 플랜의 모든 기능",
      "무제한 단어 저장",
      "무제한 리딩 퀴즈 및 해설",
      "무제한 플래시카드 학습",
      "완전한 이메일 학습 콘텐츠",
      "AI 해설 음성 듣기",
      "맞춤 뉴스 추천",
    ],
  },
  {
    id: "platinum",
    name: "Platinum",
    nameKo: "플래티넘",
    price: 6.99,
    priceYearly: 69.99,
    hasAds: false,
    features: [
      "프리미엄의 모든 기능",
      "광고 완전 제거",
      "콘텐츠 다운로드 (PDF/오프라인)",
      "우선 뉴스레터 발송",
      "고음질 TTS",
      "프리미엄 영상 콘텐츠",
      "핫샵 할인 쿠폰 (파트너십 시)",
    ],
  },
];
